import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-2 mb-3" }, " Llevas este ejército en todas tus partidas. Puedes cambiar de lista antes de cada una, pero siempre de este ejército. ", -1)

import { computed, ref, watch } from "vue";
import SelectorEjercito from "./SelectorEjercito.vue";
import CasillaPrivacidad from "@/components/Commons/CasillaPrivacidad.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalConfirmarInscripcion',
  props: {
    isVisible: { type: Boolean },
    titulo: {},
    pedirEjercito: { type: Boolean }
  },
  emits: ["update:isVisible", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const visible = computed({
  get: () => props.isVisible,
  set: valor => emit("update:isVisible", valor),
});

const ejercito = ref<string | null>(null);
// Sin marcar: el correo solo se comparte si el jugador lo elige
const compartirEmail = ref(false);
const aceptaPrivacidad = ref(false);

watch(
  () => props.isVisible,
  abierto => {
    if (!abierto) return;
    ejercito.value = null;
    compartirEmail.value = false;
    aceptaPrivacidad.value = false;
  }
);

const confirmar = () => {
  if ((props.pedirEjercito && !ejercito.value) || !aceptaPrivacidad.value)
    return;
  emit("confirm", {
    ejercito: ejercito.value,
    compartirEmail: compartirEmail.value,
  });
  visible.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
    "max-width": "480"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-wrap" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.titulo), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              (_ctx.pedirEjercito)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_1,
                    _createVNode(SelectorEjercito, {
                      modelValue: ejercito.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ejercito).value = $event))
                    }, null, 8, ["modelValue"])
                  ], 64))
                : _createCommentVNode("", true),
              _createVNode(_component_v_checkbox, {
                modelValue: compartirEmail.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((compartirEmail).value = $event)),
                color: "primary",
                density: "compact",
                "hide-details": "auto",
                label: "Compartir mi correo con el organizador",
                messages: "Para que pueda contactarte si hace falta. Puedes cambiarlo cuando quieras en Mi inscripción."
              }, null, 8, ["modelValue"]),
              _createVNode(CasillaPrivacidad, {
                modelValue: aceptaPrivacidad.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((aceptaPrivacidad).value = $event)),
                class: "mt-2"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "grey",
                variant: "text",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancelar")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                disabled: (_ctx.pedirEjercito && !ejercito.value) || !aceptaPrivacidad.value,
                onClick: confirmar
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Inscribirme ")
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})